/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Field_New_Date_RequiredInputs */

const en_cad_field_new_date_required = /** @type {(inputs: Cad_Field_New_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New date is required.`)
};

const ja_cad_field_new_date_required = /** @type {(inputs: Cad_Field_New_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい日付は必須です。`)
};

const fr_cad_field_new_date_required = /** @type {(inputs: Cad_Field_New_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La nouvelle date est requise.`)
};

const de_cad_field_new_date_required = /** @type {(inputs: Cad_Field_New_Date_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein neuer Termin ist erforderlich.`)
};

/**
* | output |
* | --- |
* | "New date is required." |
*
* @param {Cad_Field_New_Date_RequiredInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_field_new_date_required = /** @type {((inputs?: Cad_Field_New_Date_RequiredInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Field_New_Date_RequiredInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_field_new_date_required(inputs)
	if (locale === "ja") return ja_cad_field_new_date_required(inputs)
	if (locale === "fr") return fr_cad_field_new_date_required(inputs)
	return de_cad_field_new_date_required(inputs)
});